import MaxLengthNumericEditor from '../../../../../SharedModules/CustomAgGridEditor/inputComponent';
import '../../tBillRates/Components/tBillTabelHead.css';
import * as Styles from '../../../../../SharedModules/StyleConstant/StyleConstant';
import { updateHeaderArray } from '../../../../../SharedModules/utilities/utilities';
import { formatDateToSortableDateStr } from '../../../../../SharedModules/DateUtilities/DateUtilities';

function monthToComparableNumber(date) {
  if (date === undefined || date === null) {
    return null;
  }
  let dt = date;
  if (date instanceof Date && !isNaN(date.getTime())) {
    dt = formatDateToSortableDateStr(date);
  }
  if (dt.length !== 10) {
    return null;
  }
  const yearNumber = Number.parseInt(dt.substring(6, 10));
  const dayNumber = Number.parseInt(dt.substring(3, 5));
  const monthNumber = Number.parseInt(dt.substring(0, 2));
  return yearNumber * 10000 + monthNumber * 100 + dayNumber;
}

function dateComparator(date1, date2) {
  const date1Number = monthToComparableNumber(date1);
  const date2Number = monthToComparableNumber(date2);
  if (date1Number === null && date2Number === null) {
    return 0;
  }
  if (date1Number === null) {
    return -1;
  }
  if (date2Number === null) {
    return 1;
  }
  return date1Number - date2Number;
}

const IneligibleProvHeader = (localStorageValue, kcRoles, addColWidth) =>
  updateHeaderArray(
    [
      {
        headerName: 'Actions',
        cellRenderer: 'deleteBoxRenderer',
        filter: false,
        sortable: false,
        suppressMenu: false,
        showCheckboxIcon: true,
        minWidth: Styles.Length_100,
        cellStyle: {
          borderRightColor: Styles.BorderColor,
        },
        pdfExportOptions: {
          skipColumn: true,
        },
      },
      {
        headerName: 'Provider ID Type',
        field: 'providerIdTypeName',
        editable: false,
        sortable: true,
        suppressMenu: false,
        // sort: 'asc',
        wrapHeaderText: true,
        autoHeaderHeight: true,
        cellEditor: MaxLengthNumericEditor,
        minWidth: Styles.Width_130,
        cellStyle: { borderRightColor: Styles.BorderColor },
        filter: 'agTextColumnFilter',
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
      },
      {
        headerName: 'Provider ID',
        field: 'providerId',
        cellRenderer: 'linkRenderer',
        sort: 'asc',
        editable: false,
        sortable: true,
        suppressMenu: false,
        cellEditor: MaxLengthNumericEditor,
        minWidth: Styles.Width_150,
        sortingOrder: ['desc', 'asc'],
        filter: 'agTextColumnFilter',
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
        cellStyle: { borderRightColor: Styles.BorderColor },
      },

      {
        headerName: 'Provider Name',
        field: 'providerName',
        cellRenderer: 'providerNameRenderer',
        editable: false,
        sortable: true,
        columnSpan: 3,
        minWidth: addColWidth?.length > 0 ? Styles.Width_230 : Styles.Width_300,
        cellClass: 'frr-ellipsis-text-overlap',
        sortingOrder: ['desc', 'asc'],
        cellStyle: { 'border-right-color': Styles.BorderColor },
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
      },

      {
        headerName: '',
        field: '',
        removeColumn: true,
        minWidth: 1,
        resizable: false,
        editable: false,
      },
      {
        headerName: '',
        field: '',
        removeColumn: true,
        minWidth: 1,
        resizable: false,
        editable: false,
      },
      {
        headerName: 'Ineligibility Period Begin Date',
        field: 'ineligProviderBeginDt',
        wrapHeaderText: true,
        autoHeaderHeight: true,
        editable: false,
        suppressMenu: false,
        sortable: true,
        cellRenderer: 'StartDate',
        cellEditor: MaxLengthNumericEditor,
        minWidth: Styles.Width_200,
        isNumber: true,
        filter: 'agTextColumnFilter',
        comparator: dateComparator,
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
        cellStyle: { borderRightColor: Styles.BorderColor },
        required: true,
      },
      {
        headerName: 'Ineligibility Period End Date',
        field: 'endDt',
        editable: false,
        suppressMenu: false,
        sortable: true,
        wrapHeaderText: true,
        autoHeaderHeight: true,
        cellRenderer: 'EndDate',
        cellEditor: MaxLengthNumericEditor,
        minWidth: Styles.Width_200,
        isNumber: true,
        filter: 'agTextColumnFilter',
        resizable: false,
        comparator: dateComparator,
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
      },
    ],
    kcRoles
  );

export default IneligibleProvHeader;
